
import Footer from 'components/layout/Footer';

import React from 'react';
import AirplaneDisplay from './components/AircraftShowcase';
import JetSaleBanner from './components/JetSaleBanner';
import JetSaleInfo from './components/JetSaleInfo';
import HeaderMeta from 'components/headerMeta/HeaderMeta';

import { MainContainer } from './JetSale.style';

const JetSale = () => {
  return (
    <>
      <HeaderMeta type='jetSales' />
      <MainContainer>
        <JetSaleBanner />
        <AirplaneDisplay />
        <JetSaleInfo />
      </MainContainer>
      <Footer />
    </>
  );
};

export default JetSale;
